import React, { useEffect } from 'react';
import './Project.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { NavLink } from 'react-router-dom';

const Project = (props) => {
    const { title, img, live, client, server, id } = props.project;

    useEffect(() => {
        AOS.init({
            duration: 800,
        })
    }, [])
    return (
        <div className="col-md-4 pb-5" data-aos="fade-up"
            data-aos-anchor-placement="top-bottom">
            <div className="card h-100 project-hover">
                <div className="blog-img">
                    <img src={img[0]} className="card-img-top" height="250" alt="..." />
                </div>
                <div className="card-body">
                    <h5 className="card-title">{title}</h5>
                    <NavLink className="detail-btn" to={`/projectDetail/${id}`}>Details</NavLink>
                    <a href={live} style={{ textDecoration: "none", color: "#fff" }} target="_blank" rel="noreferrer">
                        <button type="button" className="btn me-1 text-white" style={{ background: "rgb(15 27 46)" }}>Live</button>
                    </a>
                    <a href={client} style={{ textDecoration: "none", color: "#fff" }} target="_blank" rel="noreferrer">
                        <button type="button" className="btn me-1 text-white" style={{ background: "#1A5E9D" }}><i className="fab fa-github"></i> Client</button>
                    </a>
                    {
                        server && <a href={server} style={{ textDecoration: "none", color: "#fff" }} target="_blank" rel="noreferrer">
                            <button type="button" className="btn text-white" style={{ background: "#2666CF" }}>Server</button>
                        </a>
                    }
                </div>
            </div>
        </div>
    );
};

export default Project;